/* tslint:disable */
/* eslint-disable */
/**
 * Pecosta Search API
 * Autocomplete / našeptávač produktů (extrahováno z portal-backend)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AutocompleteResponse
 */
export interface AutocompleteResponse {
    /**
     * 
     * @type {number}
     * @memberof AutocompleteResponse
     */
    'totalProducts'?: number;
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof AutocompleteResponse
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {Array<IndexedCategoryDTO>}
     * @memberof AutocompleteResponse
     */
    'categories': Array<IndexedCategoryDTO>;
    /**
     * 
     * @type {Array<IndexedSupplierESDTO>}
     * @memberof AutocompleteResponse
     */
    'suppliers': Array<IndexedSupplierESDTO>;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof AutocompleteResponse
     */
    'supplierDelivery'?: Array<SupplierDeliveryWindow> | null;
}
/**
 * 
 * @export
 * @interface BreadcrumbInfo
 */
export interface BreadcrumbInfo {
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof BreadcrumbInfo
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof BreadcrumbInfo
     */
    'categoryImageUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface CatalogCategoryInfo
 */
export interface CatalogCategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof CatalogCategoryInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCategoryInfo
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCategoryInfo
     */
    'categoryEcid': string;
}
/**
 * 
 * @export
 * @interface CatalogCategoryResponse
 */
export interface CatalogCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof CatalogCategoryResponse
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCategoryResponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCategoryResponse
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCategoryResponse
     */
    'categoryImage'?: string | null;
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof CatalogCategoryResponse
     */
    'firstNProducts': Array<ProductTileResponse>;
    /**
     * 
     * @type {number}
     * @memberof CatalogCategoryResponse
     */
    'totalProductsCount'?: number;
}
/**
 * 
 * @export
 * @interface CatalogReponse
 */
export interface CatalogReponse {
    /**
     * 
     * @type {Array<CatalogCategoryInfo>}
     * @memberof CatalogReponse
     */
    'breadcrumb': Array<CatalogCategoryInfo>;
    /**
     * 
     * @type {string}
     * @memberof CatalogReponse
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CatalogReponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogReponse
     */
    'categoryEcid': string;
    /**
     * 
     * @type {Array<CatalogCategoryResponse>}
     * @memberof CatalogReponse
     */
    'categories': Array<CatalogCategoryResponse>;
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof CatalogReponse
     */
    'directProducts': Array<ProductTileResponse>;
    /**
     * 
     * @type {number}
     * @memberof CatalogReponse
     */
    'totalProductsCount'?: number;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof CatalogReponse
     */
    'supplierDeliveryWindow': Array<SupplierDeliveryWindow>;
    /**
     * 
     * @type {Array<SupplierAggregation>}
     * @memberof CatalogReponse
     */
    'supplierAggregations': Array<SupplierAggregation>;
}
/**
 * 
 * @export
 * @interface CategoryAggregation
 */
export interface CategoryAggregation {
    /**
     * 
     * @type {string}
     * @memberof CategoryAggregation
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryAggregation
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof CategoryAggregation
     */
    'productCount'?: number;
}
/**
 * 
 * @export
 * @interface CategoryInfo
 */
export interface CategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof CategoryInfo
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryInfo
     */
    'categoryImageUrl'?: string | null;
    /**
     * 
     * @type {Array<SubcategoryInfo>}
     * @memberof CategoryInfo
     */
    'subcategories': Array<SubcategoryInfo>;
    /**
     * 
     * @type {Array<BreadcrumbInfo>}
     * @memberof CategoryInfo
     */
    'breadcrumb': Array<BreadcrumbInfo>;
}
/**
 * 
 * @export
 * @interface IndexedCategoryDTO
 */
export interface IndexedCategoryDTO {
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'buyerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'parentEcid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndexedCategoryDTO
     */
    'categoryImageUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IndexedCategoryDTO
     */
    'sortOrder'?: number | null;
}
/**
 * 
 * @export
 * @interface IndexedSupplierESDTO
 */
export interface IndexedSupplierESDTO {
    /**
     * 
     * @type {string}
     * @memberof IndexedSupplierESDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'supplierId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'buyerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IndexedSupplierESDTO
     */
    'portalId'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PriceType = {
    Standard: 'STANDARD',
    ActionPrice: 'ACTION_PRICE',
    SubstitutePrice: 'SUBSTITUTE_PRICE',
    FromDlPrice: 'FROM_DL_PRICE'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];


/**
 * 
 * @export
 * @interface ProductTileResponse
 */
export interface ProductTileResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'productCategory': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'catalogCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {Array<ProductTileResponseSupplier>}
     * @memberof ProductTileResponse
     */
    'suppliers': Array<ProductTileResponseSupplier>;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'buyerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTileResponse
     */
    'images': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponse
     */
    'alternativesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasCheapestVariant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'isFavorite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasValidPrice'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof ProductTileResponse
     */
    'sortValues'?: Array<any> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'isCustomProduct'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponse
     */
    'customProductCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponse
     */
    'hasSupplierPreference'?: boolean;
}
/**
 * 
 * @export
 * @interface ProductTileResponseSupplier
 */
export interface ProductTileResponseSupplier {
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'catalogName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'minimumQty': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'onlyMultiply'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'isGaranted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'basicPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'basicUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'auctionPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'auctionUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'auctionAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'packageItemUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof ProductTileResponseSupplier
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof ProductTileResponseSupplier
     */
    'price': number;
    /**
     * 
     * @type {PriceType}
     * @memberof ProductTileResponseSupplier
     */
    'priceType': PriceType;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'validPriceFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ProductTileResponseSupplier
     */
    'validPriceTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTileResponseSupplier
     */
    'isManual'?: boolean;
    /**
     * 
     * @type {SupplierPreference}
     * @memberof ProductTileResponseSupplier
     */
    'supplierPreference'?: SupplierPreference | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SortBy = {
    Relevance: 'RELEVANCE',
    SortAz: 'SORT_AZ',
    SortZa: 'SORT_ZA',
    SortPriceAsc: 'SORT_PRICE_ASC',
    SortPriceDesc: 'SORT_PRICE_DESC'
} as const;

export type SortBy = typeof SortBy[keyof typeof SortBy];


/**
 * 
 * @export
 * @interface SubcategoryInfo
 */
export interface SubcategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof SubcategoryInfo
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof SubcategoryInfo
     */
    'categoryImageUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubcategoryInfo
     */
    'productCount'?: number;
}
/**
 * 
 * @export
 * @interface SupplierAggregation
 */
export interface SupplierAggregation {
    /**
     * 
     * @type {number}
     * @memberof SupplierAggregation
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierAggregation
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof SupplierAggregation
     */
    'productCount'?: number;
}
/**
 * 
 * @export
 * @interface SupplierDeliveryWindow
 */
export interface SupplierDeliveryWindow {
    /**
     * 
     * @type {number}
     * @memberof SupplierDeliveryWindow
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplierDeliveryWindow
     */
    'deliveryWindow'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SupplierPreference = {
    Preferred: 'PREFERRED',
    NonPreferred: 'NON_PREFERRED'
} as const;

export type SupplierPreference = typeof SupplierPreference[keyof typeof SupplierPreference];


/**
 * 
 * @export
 * @enum {string}
 */

export const UnitType = {
    Kilogram: 'KILOGRAM',
    Kus: 'KUS',
    Baleni: 'BALENI',
    Litr: 'LITR',
    Kbelik: 'KBELIK',
    Role: 'ROLE',
    Krabice: 'KRABICE',
    Jednotka: 'JEDNOTKA',
    Hodina: 'HODINA',
    MetrCtverecni: 'METR_CTVERECNI',
    Sada: 'SADA',
    Svazek: 'SVAZEK',
    Par: 'PAR',
    Souprava: 'SOUPRAVA',
    Gram: 'GRAM',
    Mililitr: 'MILILITR',
    Tableta: 'TABLETA',
    Pytel: 'PYTEL',
    Doza: 'DOZA',
    Kilometr: 'KILOMETR',
    List: 'LIST',
    Metr: 'METR',
    Kanystr: 'KANYSTR',
    Vana: 'VANA',
    KorunaCeska: 'KORUNA_CESKA',
    Davka: 'DAVKA',
    Blok: 'BLOK',
    Karton: 'KARTON',
    Piece: 'PIECE',
    Kr: 'KR',
    Lt: 'LT',
    Pk: 'PK',
    Ct: 'CT',
    St: 'ST'
} as const;

export type UnitType = typeof UnitType[keyof typeof UnitType];


/**
 * 
 * @export
 * @interface VirtualScrollResponseDTO
 */
export interface VirtualScrollResponseDTO {
    /**
     * 
     * @type {Array<ProductTileResponse>}
     * @memberof VirtualScrollResponseDTO
     */
    'products': Array<ProductTileResponse>;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'startIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualScrollResponseDTO
     */
    'endIndex'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualScrollResponseDTO
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {CategoryInfo}
     * @memberof VirtualScrollResponseDTO
     */
    'categoryInfo'?: CategoryInfo | null;
    /**
     * 
     * @type {Array<SupplierDeliveryWindow>}
     * @memberof VirtualScrollResponseDTO
     */
    'supplierDelivery'?: Array<SupplierDeliveryWindow> | null;
    /**
     * 
     * @type {Array<SupplierAggregation>}
     * @memberof VirtualScrollResponseDTO
     */
    'supplierAggregations'?: Array<SupplierAggregation> | null;
    /**
     * 
     * @type {Array<CategoryAggregation>}
     * @memberof VirtualScrollResponseDTO
     */
    'categoryAggregations'?: Array<CategoryAggregation> | null;
}

/**
 * AutocompleteApi - axios parameter creator
 * @export
 */
export const AutocompleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fulltextové vyhledávání produktů v Elasticsearch obohacené o data z PostgreSQL (delivery windows, validita cen, alternativy, agregace dodavatelů a kategorií).
         * @summary Autocomplete produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} query 
         * @param {SortBy} sortBy 
         * @param {Array<number>} supplierIds 
         * @param {string | null} [categoryEcid] 
         * @param {number} [endIndex] 
         * @param {boolean | null} [filterGarantedPrice] 
         * @param {PriceType | null} [filterPriceType] 
         * @param {number} [startIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (organizationId: number, portalId: number, query: string, sortBy: SortBy, supplierIds: Array<number>, categoryEcid?: string | null, endIndex?: number, filterGarantedPrice?: boolean | null, filterPriceType?: PriceType | null, startIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('search', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('search', 'portalId', portalId)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('search', 'query', query)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('search', 'sortBy', sortBy)
            // verify required parameter 'supplierIds' is not null or undefined
            assertParamExists('search', 'supplierIds', supplierIds)
            const localVarPath = `/api/autocomplete/{organizationId}/{portalId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (endIndex !== undefined) {
                localVarQueryParameter['endIndex'] = endIndex;
            }

            if (filterGarantedPrice !== undefined) {
                localVarQueryParameter['filterGarantedPrice'] = filterGarantedPrice;
            }

            if (filterPriceType !== undefined) {
                localVarQueryParameter['filterPriceType'] = filterPriceType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (startIndex !== undefined) {
                localVarQueryParameter['startIndex'] = startIndex;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutocompleteApi - functional programming interface
 * @export
 */
export const AutocompleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutocompleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Fulltextové vyhledávání produktů v Elasticsearch obohacené o data z PostgreSQL (delivery windows, validita cen, alternativy, agregace dodavatelů a kategorií).
         * @summary Autocomplete produktů
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} query 
         * @param {SortBy} sortBy 
         * @param {Array<number>} supplierIds 
         * @param {string | null} [categoryEcid] 
         * @param {number} [endIndex] 
         * @param {boolean | null} [filterGarantedPrice] 
         * @param {PriceType | null} [filterPriceType] 
         * @param {number} [startIndex] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(organizationId: number, portalId: number, query: string, sortBy: SortBy, supplierIds: Array<number>, categoryEcid?: string | null, endIndex?: number, filterGarantedPrice?: boolean | null, filterPriceType?: PriceType | null, startIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VirtualScrollResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(organizationId, portalId, query, sortBy, supplierIds, categoryEcid, endIndex, filterGarantedPrice, filterPriceType, startIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutocompleteApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutocompleteApi - factory interface
 * @export
 */
export const AutocompleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutocompleteApiFp(configuration)
    return {
        /**
         * Fulltextové vyhledávání produktů v Elasticsearch obohacené o data z PostgreSQL (delivery windows, validita cen, alternativy, agregace dodavatelů a kategorií).
         * @summary Autocomplete produktů
         * @param {AutocompleteApiSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(requestParameters: AutocompleteApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<VirtualScrollResponseDTO> {
            return localVarFp.search(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.sortBy, requestParameters.supplierIds, requestParameters.categoryEcid, requestParameters.endIndex, requestParameters.filterGarantedPrice, requestParameters.filterPriceType, requestParameters.startIndex, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutocompleteApi - interface
 * @export
 * @interface AutocompleteApi
 */
export interface AutocompleteApiInterface {
    /**
     * Fulltextové vyhledávání produktů v Elasticsearch obohacené o data z PostgreSQL (delivery windows, validita cen, alternativy, agregace dodavatelů a kategorií).
     * @summary Autocomplete produktů
     * @param {AutocompleteApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApiInterface
     */
    search(requestParameters: AutocompleteApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<VirtualScrollResponseDTO>;

}

/**
 * Request parameters for search operation in AutocompleteApi.
 * @export
 * @interface AutocompleteApiSearchRequest
 */
export interface AutocompleteApiSearchRequest {
    /**
     * 
     * @type {number}
     * @memberof AutocompleteApiSearch
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AutocompleteApiSearch
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof AutocompleteApiSearch
     */
    readonly query: string

    /**
     * 
     * @type {SortBy}
     * @memberof AutocompleteApiSearch
     */
    readonly sortBy: SortBy

    /**
     * 
     * @type {Array<number>}
     * @memberof AutocompleteApiSearch
     */
    readonly supplierIds: Array<number>

    /**
     * 
     * @type {string}
     * @memberof AutocompleteApiSearch
     */
    readonly categoryEcid?: string | null

    /**
     * 
     * @type {number}
     * @memberof AutocompleteApiSearch
     */
    readonly endIndex?: number

    /**
     * 
     * @type {boolean}
     * @memberof AutocompleteApiSearch
     */
    readonly filterGarantedPrice?: boolean | null

    /**
     * 
     * @type {PriceType}
     * @memberof AutocompleteApiSearch
     */
    readonly filterPriceType?: PriceType | null

    /**
     * 
     * @type {number}
     * @memberof AutocompleteApiSearch
     */
    readonly startIndex?: number
}

/**
 * AutocompleteApi - object-oriented interface
 * @export
 * @class AutocompleteApi
 * @extends {BaseAPI}
 */
export class AutocompleteApi extends BaseAPI implements AutocompleteApiInterface {
    /**
     * Fulltextové vyhledávání produktů v Elasticsearch obohacené o data z PostgreSQL (delivery windows, validita cen, alternativy, agregace dodavatelů a kategorií).
     * @summary Autocomplete produktů
     * @param {AutocompleteApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    public search(requestParameters: AutocompleteApiSearchRequest, options?: RawAxiosRequestConfig) {
        return AutocompleteApiFp(this.configuration).search(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.sortBy, requestParameters.supplierIds, requestParameters.categoryEcid, requestParameters.endIndex, requestParameters.filterGarantedPrice, requestParameters.filterPriceType, requestParameters.startIndex, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogApi - axios parameter creator
 * @export
 */
export const CatalogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí podkategorie s prvními N produkty, breadcrumb a agregace dodavatelů.
         * @summary Katalog po kategoriích
         * @param {number} buyerId 
         * @param {number} portalId 
         * @param {string} categoryEcid 
         * @param {Array<number>} supplierIds 
         * @param {number} [firstNProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: async (buyerId: number, portalId: number, categoryEcid: string, supplierIds: Array<number>, firstNProducts?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerId' is not null or undefined
            assertParamExists('getCatalog', 'buyerId', buyerId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getCatalog', 'portalId', portalId)
            // verify required parameter 'categoryEcid' is not null or undefined
            assertParamExists('getCatalog', 'categoryEcid', categoryEcid)
            // verify required parameter 'supplierIds' is not null or undefined
            assertParamExists('getCatalog', 'supplierIds', supplierIds)
            const localVarPath = `/catalog/{portalId}/{buyerId}`
                .replace(`{${"buyerId"}}`, encodeURIComponent(String(buyerId)))
                .replace(`{${"portalId"}}`, encodeURIComponent(String(portalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (firstNProducts !== undefined) {
                localVarQueryParameter['firstNProducts'] = firstNProducts;
            }

            if (supplierIds) {
                localVarQueryParameter['supplierIds'] = supplierIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogApi - functional programming interface
 * @export
 */
export const CatalogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí podkategorie s prvními N produkty, breadcrumb a agregace dodavatelů.
         * @summary Katalog po kategoriích
         * @param {number} buyerId 
         * @param {number} portalId 
         * @param {string} categoryEcid 
         * @param {Array<number>} supplierIds 
         * @param {number} [firstNProducts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalog(buyerId: number, portalId: number, categoryEcid: string, supplierIds: Array<number>, firstNProducts?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalog(buyerId, portalId, categoryEcid, supplierIds, firstNProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogApi.getCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogApi - factory interface
 * @export
 */
export const CatalogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogApiFp(configuration)
    return {
        /**
         * Vrátí podkategorie s prvními N produkty, breadcrumb a agregace dodavatelů.
         * @summary Katalog po kategoriích
         * @param {CatalogApiGetCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog(requestParameters: CatalogApiGetCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<CatalogReponse> {
            return localVarFp.getCatalog(requestParameters.buyerId, requestParameters.portalId, requestParameters.categoryEcid, requestParameters.supplierIds, requestParameters.firstNProducts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogApi - interface
 * @export
 * @interface CatalogApi
 */
export interface CatalogApiInterface {
    /**
     * Vrátí podkategorie s prvními N produkty, breadcrumb a agregace dodavatelů.
     * @summary Katalog po kategoriích
     * @param {CatalogApiGetCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApiInterface
     */
    getCatalog(requestParameters: CatalogApiGetCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<CatalogReponse>;

}

/**
 * Request parameters for getCatalog operation in CatalogApi.
 * @export
 * @interface CatalogApiGetCatalogRequest
 */
export interface CatalogApiGetCatalogRequest {
    /**
     * 
     * @type {number}
     * @memberof CatalogApiGetCatalog
     */
    readonly buyerId: number

    /**
     * 
     * @type {number}
     * @memberof CatalogApiGetCatalog
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof CatalogApiGetCatalog
     */
    readonly categoryEcid: string

    /**
     * 
     * @type {Array<number>}
     * @memberof CatalogApiGetCatalog
     */
    readonly supplierIds: Array<number>

    /**
     * 
     * @type {number}
     * @memberof CatalogApiGetCatalog
     */
    readonly firstNProducts?: number
}

/**
 * CatalogApi - object-oriented interface
 * @export
 * @class CatalogApi
 * @extends {BaseAPI}
 */
export class CatalogApi extends BaseAPI implements CatalogApiInterface {
    /**
     * Vrátí podkategorie s prvními N produkty, breadcrumb a agregace dodavatelů.
     * @summary Katalog po kategoriích
     * @param {CatalogApiGetCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogApi
     */
    public getCatalog(requestParameters: CatalogApiGetCatalogRequest, options?: RawAxiosRequestConfig) {
        return CatalogApiFp(this.configuration).getCatalog(requestParameters.buyerId, requestParameters.portalId, requestParameters.categoryEcid, requestParameters.supplierIds, requestParameters.firstNProducts, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoResourceApi - axios parameter creator
 * @export
 */
export const InfoResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoResourceApi - functional programming interface
 * @export
 */
export const InfoResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoResourceApi.infoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoResourceApi - factory interface
 * @export
 */
export const InfoResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.infoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoResourceApi - interface
 * @export
 * @interface InfoResourceApi
 */
export interface InfoResourceApiInterface {
    /**
     * 
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApiInterface
     */
    infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * InfoResourceApi - object-oriented interface
 * @export
 * @class InfoResourceApi
 * @extends {BaseAPI}
 */
export class InfoResourceApi extends BaseAPI implements InfoResourceApiInterface {
    /**
     * 
     * @summary Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApi
     */
    public infoGet(options?: RawAxiosRequestConfig) {
        return InfoResourceApiFp(this.configuration).infoGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí produkty, kategorie i dodavatele matchující dotaz.
         * @summary Kombinovaný autocomplete
         * @param {string} query 
         * @param {number} [customerId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete: async (query: string, customerId?: number, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('autoComplete', 'query', query)
            const localVarPath = `/api/search/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí produkty, kategorie i dodavatele matchující dotaz.
         * @summary Kombinovaný autocomplete
         * @param {string} query 
         * @param {number} [customerId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoComplete(query: string, customerId?: number, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoComplete(query, customerId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.autoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * Vrátí produkty, kategorie i dodavatele matchující dotaz.
         * @summary Kombinovaný autocomplete
         * @param {SearchApiAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoComplete(requestParameters: SearchApiAutoCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutocompleteResponse> {
            return localVarFp.autoComplete(requestParameters.query, requestParameters.customerId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - interface
 * @export
 * @interface SearchApi
 */
export interface SearchApiInterface {
    /**
     * Vrátí produkty, kategorie i dodavatele matchující dotaz.
     * @summary Kombinovaný autocomplete
     * @param {SearchApiAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    autoComplete(requestParameters: SearchApiAutoCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutocompleteResponse>;

}

/**
 * Request parameters for autoComplete operation in SearchApi.
 * @export
 * @interface SearchApiAutoCompleteRequest
 */
export interface SearchApiAutoCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchApiAutoComplete
     */
    readonly query: string

    /**
     * 
     * @type {number}
     * @memberof SearchApiAutoComplete
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof SearchApiAutoComplete
     */
    readonly portalId?: number
}

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI implements SearchApiInterface {
    /**
     * Vrátí produkty, kategorie i dodavatele matchující dotaz.
     * @summary Kombinovaný autocomplete
     * @param {SearchApiAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public autoComplete(requestParameters: SearchApiAutoCompleteRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).autoComplete(requestParameters.query, requestParameters.customerId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



